'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _cartImage = require('../../../components/generic/image-handling/cart-image');

var _cartImage2 = _interopRequireDefault(_cartImage);

var _Utility = require('../../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderDetail = function (_React$Component) {
    _inherits(OrderDetail, _React$Component);

    function OrderDetail() {
        _classCallCheck(this, OrderDetail);

        return _possibleConstructorReturn(this, (OrderDetail.__proto__ || Object.getPrototypeOf(OrderDetail)).apply(this, arguments));
    }

    _createClass(OrderDetail, [{
        key: 'getActualItem',
        value: function getActualItem(itemObjectId) {
            return this.props.itemDetails.find(function (itemDetail) {
                return itemDetail.objectId === itemObjectId;
            });
        }
    }, {
        key: 'generateChosenOptionsList',
        value: function generateChosenOptionsList(chosenOptions, options) {
            var res = chosenOptions.map(function (cOption) {
                var key = cOption.optionCategoryName;
                var idx = _lodash2.default.findIndex(options, function (option) {
                    return option.category.trim() == key.trim();
                });

                var coKeyVal = cOption.selectedKeys.reduce(function (acc, key) {
                    acc[key] = (acc[key] || 0) + 1;
                    return acc;
                }, {});

                return Object.keys(coKeyVal).map(function (key, i) {
                    var price = "";
                    var optionPrefix = "";
                    if (options[idx][key] !== 0) {
                        price = '$' + options[idx][key];
                    }

                    if (coKeyVal[key] > 1) {
                        optionPrefix = ' - ' + coKeyVal[key] + ' x ';
                    }

                    return _react2.default.createElement(
                        'li',
                        { key: key + '-' + i + '-' + idx, className: 'small' },
                        key,
                        optionPrefix,
                        price
                    );
                });
            });
            return _react2.default.createElement(
                'ul',
                { className: 'list-unstyled' },
                res
            );
        }
    }, {
        key: 'generateChosenOptionsListNew',
        value: function generateChosenOptionsListNew(chosenOptions) {

            var res = chosenOptions.map(function (cOption) {
                var coKeyVal = cOption.selectedKeys.reduce(function (acc, key) {
                    acc[key] = (acc[key] || 0) + 1;
                    return acc;
                }, {});

                return Object.keys(coKeyVal).map(function (key, i) {
                    var optionPrefix = "";

                    if (coKeyVal[key] > 1) {
                        optionPrefix = coKeyVal[key] + ' x ';
                    }

                    return _react2.default.createElement(
                        'li',
                        { key: key + '-' + i + '-' + coKeyVal[key], className: 'small' },
                        optionPrefix,
                        key
                    );
                });
            });

            return _react2.default.createElement(
                'ul',
                { className: 'list-unstyled' },
                res
            );
        }
    }, {
        key: 'getCouponStructure',
        value: function getCouponStructure(order) {
            var couponInfo = order.couponInfo;
            if (couponInfo && !Utils.isEmptyObj(couponInfo)) {
                var component = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        { className: 'disc-highlight' },
                        'Applied coupon ',
                        _react2.default.createElement(
                            'b',
                            null,
                            couponInfo.couponCode
                        ),
                        ' for this order.'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'p',
                        null,
                        'sub total ',
                        _react2.default.createElement(
                            'b',
                            { className: 'pull-right cart-header' },
                            ' $',
                            Utils.toRoundStr(order.subTotal, 2)
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'disc-highlight' },
                        'Discount ',
                        _react2.default.createElement(
                            'b',
                            { className: 'pull-right cart-header' },
                            ' -$',
                            Number(couponInfo.discountAmount).toFixed(2)
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Discounted sub total ',
                        _react2.default.createElement(
                            'b',
                            { className: 'pull-right cart-header' },
                            ' $',
                            Number(order.subTotal - couponInfo.discountAmount).toFixed(2)
                        )
                    )
                );
                return component;
            } else {
                return _react2.default.createElement(
                    'p',
                    null,
                    'sub total ',
                    _react2.default.createElement(
                        'b',
                        { className: 'pull-right cart-header' },
                        ' $',
                        Utils.toRoundStr(order.subTotal, 2)
                    )
                );
            }
        }
    }, {
        key: 'getDeliveryFeeStructure',
        value: function getDeliveryFeeStructure(order) {
            var component = null;

            if (order.deliveryFee) {
                component = _react2.default.createElement(
                    'p',
                    null,
                    'delivery fee',
                    _react2.default.createElement(
                        'b',
                        { className: 'pull-right cart-header' },
                        '$',
                        Utils.toRoundStr(order.deliveryFee, 2)
                    )
                );
            }

            return component;
        }
    }, {
        key: 'getServiceFeeStructure',
        value: function getServiceFeeStructure(order) {
            var component = null;

            if (order.serviceFee) {
                component = _react2.default.createElement(
                    'p',
                    null,
                    'service fee',
                    _react2.default.createElement(
                        'b',
                        { className: 'pull-right cart-header' },
                        '$',
                        Utils.toRoundStr(order.serviceFee, 2)
                    )
                );
            }

            return component;
        }
    }, {
        key: 'getDriverTipStructure',
        value: function getDriverTipStructure(order) {
            var component = null;
            if (order.tipAmount) {
                component = _react2.default.createElement(
                    'p',
                    null,
                    'tip',
                    _react2.default.createElement(
                        'b',
                        { className: 'pull-right cart-header' },
                        '$',
                        _lodash2.default.round(order.tipAmount || 0, 2).toFixed(2)
                    )
                );
            }
            return component;
        }
    }, {
        key: 'getCustomChargeStructureOfOptional',
        value: function getCustomChargeStructureOfOptional(order) {

            var customCharges = order.charge;
            if (customCharges != undefined && customCharges.length > 0) {

                return customCharges.map(function (charge, index, array) {

                    var component = null;

                    if (charge.type == "O" && !Utils.isEmpty(charge.optionName)) {
                        component = _react2.default.createElement(
                            'div',
                            { key: index, className: 'col-lg-12 optional-charge-view' },
                            _react2.default.createElement(
                                'span',
                                { className: 'opt-charge cart-header' },
                                _react2.default.createElement(
                                    'strong',
                                    null,
                                    charge.name
                                ),
                                ' : ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    charge.optionName
                                )
                            )
                        );
                    }
                    return component;
                });
            }
        }
    }, {
        key: 'getCustomChargeStructure',
        value: function getCustomChargeStructure(order) {

            var customCharges = order.charge;
            if (customCharges != undefined && customCharges.length > 0) {

                return customCharges.map(function (charge, index, array) {

                    var descComponent = null;
                    if (!Utils.isEmpty(charge.desc)) {
                        descComponent = _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(
                                'a',
                                { 'data-tip': charge.desc, className: 'color-styl tooltip-button',
                                    style: { cursor: 'pointer' } },
                                _react2.default.createElement('i', {
                                    className: 'fa fa-info-circle'
                                })
                            ),
                            _react2.default.createElement(_reactTooltip2.default, { place: 'right', wrapper: 'span' })
                        );
                    }

                    return _react2.default.createElement(
                        'p',
                        { key: index },
                        charge.name,
                        ' ',
                        descComponent,
                        _react2.default.createElement(
                            'b',
                            {
                                className: 'pull-right cart-header' },
                            '$',
                            Utils.toRoundStr(charge.fee, 2)
                        )
                    );
                });
            }
        }
    }, {
        key: 'getItemInstructions',
        value: function getItemInstructions(itemOrderInst) {
            if (Utils.isEmpty(itemOrderInst)) {
                return null;
            }

            return _react2.default.createElement(
                'ul',
                { className: 'list-unstyled' },
                _react2.default.createElement(
                    'li',
                    { key: "list-order-ins" },
                    _react2.default.createElement(
                        'b',
                        null,
                        'Instructions: '
                    ),
                    '' + itemOrderInst
                )
            );
        }
    }, {
        key: 'renderOrderRow',
        value: function renderOrderRow() {
            var self = this;
            return this.props.order.items.map(function (item, index, array) {

                var actualItem = self.getActualItem(item.itemObjectId);
                var link = "";

                if (actualItem && actualItem.mediaArray && actualItem.mediaArray.length > 0) {
                    link = actualItem.mediaArray[0].url;
                }

                return _react2.default.createElement(
                    'tr',
                    { key: item.itemObjectId + index },
                    _react2.default.createElement(
                        'td',
                        { className: 'col-xs-11 optional-charge-view', style: { textAlign: "left" } },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'h4',
                                { className: 'item-in-cart' },
                                item.itemName
                            ),
                            _react2.default.createElement(
                                'h5',
                                null,
                                ' Qty: ',
                                item.itemQty,
                                ' x $',
                                item.itemPrice
                            ),
                            self.generateChosenOptionsListNew(item.itemOptionCategories),
                            self.getItemInstructions(item.itemOrderInst)
                        )
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'col-xs-1 text-center item-cart-price', style: { paddingTop: 20 } },
                        _react2.default.createElement(
                            'strong',
                            null,
                            '$',
                            item.itemQtyPrice ? Utils.toRoundStr(item.itemQtyPrice, 2) : Utils.toRoundStr(item.itemPrice * item.itemQty, 2)
                        )
                    )
                );
            });
        }
    }, {
        key: 'getOrderDetails',
        value: function getOrderDetails(order) {

            var component = null;
            var utensilsAndNapkins = "No";
            var self = this;
            var isDineInEnabled = false;

            if (order.orderType == "PickUp" && !Utils.isEmptyObj(order.curbsidePickup)) {
                component =
                // <div className="custom-order-details-right 6">
                _react2.default.createElement(
                    'div',
                    { className: 'row order-struct-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container', style: { maxWidth: '100%' } },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12 order-struct' },
                            _react2.default.createElement(
                                'div',
                                { className: 'order-detail-group mt-10 mb-10' },
                                _react2.default.createElement(
                                    'h4',
                                    { className: 'item-in-cart' },
                                    'Vehicle Details: ',
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'text-secondary-light ft-14' },
                                        order.curbsidePickup.vColor,
                                        ',',
                                        " ",
                                        ' ',
                                        order.curbsidePickup.vMakeModel
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'padding-item-cart-container' },
                        _react2.default.createElement('div', { className: 'cart_border', style: { maxWidth: '100%' } })
                    )
                )

                // </div>
                ;
            } else {
                component = null;
            }

            if (order.orderType == "Delivery") {

                // const order       = this.props.order;
                var currentUser = _parse2.default.User.current();
                var address = "";

                if (order === null) {
                    return "";
                }

                if (!Utils.isEmptyObj(currentUser)) {
                    address = currentUser.get("name") + ',' + order.deliveryAddLine1 + '\n                ' + order.deliveryAddLine2 + ', ' + order.deliveryCity + ', ' + order.deliveryState + ' ' + order.deliveryZip + '\n                ' + Utils.formatPhoneNumber(order.deliveryPhone);
                } else {
                    address = order.userInfo.name + ', ' + order.deliveryAddLine1 + '\n                ' + order.deliveryAddLine2 + ', ' + order.deliveryCity + ', ' + order.deliveryState + ' ' + order.deliveryZip + '\n                ' + Utils.formatPhoneNumber(order.deliveryPhone);
                }

                component = _react2.default.createElement(
                    'div',
                    { className: 'row order-struct-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container', style: { maxWidth: '100%' } },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12 order-struct' },
                            _react2.default.createElement(
                                'div',
                                { className: 'order-detail-group mt-10 mb-10' },
                                _react2.default.createElement(
                                    'h4',
                                    { className: 'item-in-cart' },
                                    'Delivery Address: ',
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'text-secondary-light ft-14' },
                                        address
                                    )
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'padding-item-cart-container' },
                        _react2.default.createElement('div', { className: 'cart_border', style: { maxWidth: '100%' } })
                    )
                );
            }

            if (order.orderType == "DineIn" && !Utils.isEmptyObj(order.dineIn)) {

                order.orderType = "DineIn";

                isDineInEnabled = true;

                var slData = null;
                var dispStr = "";

                if (order.dineIn && order.dineIn.serviceLocation) {
                    dispStr = order.dineIn.serviceLocation;
                } else {
                    dispStr = "Table";
                }

                if (order.dineIn && order.dineIn.slData) {
                    slData = order.dineIn.slData;
                } else if (order.dineIn && order.dineIn.tableNumber) {
                    slData = order.dineIn.tableNumber;
                } else {
                    slData = "Not Available";
                }

                component = _react2.default.createElement(
                    'div',
                    { className: 'row order-struct-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container', style: { maxWidth: '100%' } },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12 order-struct' },
                            _react2.default.createElement(
                                'div',
                                { className: 'order-detail-group mt-10 mb-10' },
                                _react2.default.createElement(
                                    'h4',
                                    { className: 'item-in-cart' },
                                    'Room Number Testing: ',
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'text-secondary-light ft-14' },
                                        slData
                                    ),
                                    ' '
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'padding-item-cart-container' },
                        _react2.default.createElement('div', { className: 'cart_border', style: { maxWidth: '100%' } })
                    )
                );
            }

            return component;
        }
    }, {
        key: 'render',
        value: function render() {
            var order = this.props.order;
            var orderDetail = this.props.orderDetail;
            return _react2.default.createElement(
                'div',
                { className: 'section order-detail-pg order-success-pg' },
                _react2.default.createElement(
                    'div',
                    { className: 'container', style: { maxWidth: '100%' } },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12 col-md-12 order-item-container text-left mt-20' },
                            _react2.default.createElement(
                                'table',
                                { className: 'table table-hover table-fixed mb-0' },
                                _react2.default.createElement(
                                    'thead',
                                    null,
                                    _react2.default.createElement('tr', null)
                                ),
                                _react2.default.createElement(
                                    'tbody',
                                    null,
                                    this.renderOrderRow()
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'container padding-item-cart-container', style: { maxWidth: '100%' } },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'cart_border' },
                                        this.getCustomChargeStructureOfOptional(order)
                                    )
                                )
                            ),
                            this.getOrderDetails(order),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'container padding-item-cart-container', style: { maxWidth: '100%' } },
                                    _react2.default.createElement(
                                        'div',
                                        { className: '' },
                                        this.getCustomChargeStructureOfOptional(order),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'col-sm-offset-5 col-sm-7' },
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'cart_right text-secondary-light' },
                                                this.getCouponStructure(order),
                                                this.getDeliveryFeeStructure(order),
                                                _react2.default.createElement(
                                                    'p',
                                                    null,
                                                    'Tax ',
                                                    _react2.default.createElement(
                                                        'b',
                                                        { className: 'pull-right cart-header' },
                                                        ' $',
                                                        Utils.toRoundStr(order.taxes, 2)
                                                    )
                                                ),
                                                this.getServiceFeeStructure(order),
                                                this.getDriverTipStructure(order),
                                                this.getCustomChargeStructure(order)
                                            ),
                                            _react2.default.createElement(
                                                'div',
                                                { className: 'cart_total' },
                                                _react2.default.createElement(
                                                    'h4',
                                                    null,
                                                    'Total',
                                                    _react2.default.createElement(
                                                        'span',
                                                        { className: 'pull-right cart-header' },
                                                        ' $',
                                                        Utils.toRoundStr(order.totalAmount, 2)
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return OrderDetail;
}(_react2.default.Component);

exports.default = OrderDetail;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/cart-left/OrderDetail.jsx
// module id = 740
// module chunks = 0